<template>
    <div v-if="show" class="user-panel">
        <table v-if="isExpireTrialContract()" width=100% class="alertfield">
            <tr v-if="isBillingPaper()" class="alertrecord" v-t="{ path: 'message.info_trial_expire_notice_for_customer', args: { expireDate: getExpireDateTime() } }"></tr>
            <tr v-else class="alertrecord" v-t="{ path: 'message.info_trial_expire_notice_for_web', args: { expireDate: getExpireDateTime() } }"></tr>
        </table>
        <table v-else-if="isExpirePurchasedContract()" width=100% class="alertfield">
            <tr v-if="isBillingPaper()" class="alertrecord" v-t="{ path: 'message.info_contract_expire_notice_for_customer', args: { expireDate: getExpireDateTime() } }"></tr>
            <tr v-else class="alertrecord" v-t="{ path: 'message.info_contract_expire_notice_for_web', args: { expireDate: getExpireDateTime() } }"></tr>
        </table>
        <table v-else-if="appData.loginIdNotConfirmed" width=100% class="alertfield">
            <tr class="alertrecord"  v-t="{ path: 'message.info_cannot_confirm_user_attribute', args: { loginId: appData.loginId, userId:appData.loginId.split('@')[0]} }">
            </tr>
        </table>
        <table height=100% width=100% cellpadding=0 cellspacing=0>
            <tr height="56px">
                <td colspan=2>
                    <div class="command-area">
                        <div class="command-area-left">
                            <span v-if="disableCreateGroup">
                                <el-tooltip effect="light" placement="top-start" >
                                    <div v-if="appData.csvProcessing" slot="content" style="text-align:left" v-t="'message.error_import_processing'"></div>
                                    <div v-else slot="content" style="text-align:left" v-t="'message.hint_create_layer'"></div>
                                    <el-button class="disable-command-button" style="width:140px" v-t="'message.action_create_layer'"></el-button>
                                </el-tooltip>
                            </span>
                            <span v-else>
                                <el-button class="enable-command-button" style="width:140px" v-on:click="addGroupCommand()" v-t="'message.action_create_layer'"></el-button>
                            </span>
                            <span v-if="disableCreateUser">
                                <el-tooltip effect="light" placement="top-start" >
                                    <div v-if="appData.csvProcessing" slot="content" style="text-align:left" v-t="'message.error_import_processing'"></div>
                                    <div v-else slot="content" style="text-align:left" v-t="'message.hint_create_user'"></div>
                                    <el-button class="disable-command-button" style="width:140px" v-t="'message.action_create_user'"></el-button>
                                </el-tooltip>
                            </span>
                            <span v-else>
                                <el-button class="enable-command-button" style="width:140px" v-on:click="addUserCommand()" v-t="'message.action_create_user'"></el-button>
                            </span>
                            <span v-if="disableCreateTalkgroup">
                                <el-tooltip effect="light" placement="top-start" >
                                    <div v-if="appData.csvProcessing" slot="content" style="text-align:left" v-t="'message.error_import_processing'"></div>
                                    <div v-else slot="content" style="text-align:left" v-t="'message.hint_create_group'"></div>
                                    <el-button class="disable-command-button" style="width:140px" v-t="'message.action_create_group'"></el-button>
                                </el-tooltip>
                            </span>
                            <span v-else>
                                <el-button class="enable-command-button" style="width:140px" v-on:click="addTalkgroupCommand()" v-t="'message.action_create_group'"></el-button>
                            </span>
                        </div>
                        <div class="command-area-right">
                            <el-popover placement="left" width="230" trigger="manual" v-model="showCsvProcessing">
                                <div class="csv-progress-title">
                                    {{ csvProcessStatusDescription }}
                                </div>
                                <div v-if="showImportCsvProcess">
                                    <div v-if="csvErrorCount > 0" class="csv-progress-title" style="padding-top:0px" v-t="{ path: 'message.item_error_count', args: { csvErrorCount: csvErrorCount } }">
                                    </div>
                                    <el-progress :text-inside="true" :stroke-width="18" color="#5171cb" :percentage="csvProgress"></el-progress>
                                    <div v-if="(!csvProcessedAll) && (!csvAborted)" style="padding:20px 0 0 0;text-align:center">
                                        <el-button class="dialog-small-button" @click="handleCancelImport()" :disabled="canceling" v-t="'message.action_cancel_process'"></el-button>
                                    </div>
                                    <div v-else-if="(csvErrorCount == 0) && csvAborted" style="padding:20px 0 0 0;text-align:center">
                                        <el-button class="dialog-small-button" @click="handleCloseCSVProgress()" v-t="'message.button_ok'"></el-button>
                                    </div>
                                    <div v-else style="padding:20px 0 0 0;text-align:center">
                                        <el-button class="dialog-small-button" @click="handleCloseCSVProgress()" v-t="'message.action_confirm_error'"></el-button>
                                    </div>
                                </div>
                                <div v-else>
                                    <div v-if="showExportCsvProcess" style="padding:10px 0;text-align:center" v-t="{ path: 'message.item_csv_execution_time', args: { execTime: csvExportExecTime } }"></div>
                                </div>
                                <button slot="reference" class="transparent" type="button" @click="handleShowCsvDialog()">
                                    <img src="../assets/icon_csv.svg"/><span class="normal-command" v-t="'message.action_csv_import'"></span>
                                </button>
                            </el-popover>
                        </div>
                    </div>
                </td>
            </tr>
            <tr class="itemheader" style="border:none">
                <td width="50%" height="100%">
                    <div class="inner-panel">
                        <div class="objectTree">
                            <objecttree
                                v-bind:initialData="appData.tenantList"
                                @on-selectnode="handleOnSelectNode"
                                @changeListType="handleChangeListType"
                                :showAdminUser="true"
                                ref="objectTree">
                            </objecttree>
                        </div>
                    </div>
                </td>
                <td width="50%">
                    <div class="inner-panel">
                        <div class="scrollable">
                            <component
                                v-bind:selectedNode="selectedNode"
                                v-bind:appData="appData"
                                v-bind:listType="listType"
                                :is="selectedChild"
                                ref="objectInfo"
                                @setaclinfo="setAclInfo"
                                @resetSelectedNode="resetSelectedNode"
                                @refresh="handleRefreshObjectTree">
                            </component>
                        </div>
                    </div>
                </td>
            </tr>
        </table>
        <addgroup v-if="showAddGroup" :appData="appData" :selectedNode="this.selectedNode" :aclInfo="this.aclInfo" @add="addGroup" @cancel="showAddGroup=false"></addgroup>
        <addtalkgroup v-if="showAddTalkgroup" @add="addTalkgroup" @showManual="showManual()" @cancel="showAddTalkgroup=false" :appData=appData></addtalkgroup>
        <adduser v-if="showAddUser" @add="addUser" @cancel="showAddUser=false" :appData=appData></adduser>
        <importcsv v-if="showImportUser" :showErrorInfo="showImportError" :csvResult="importErrorInfo" @import="importUser" @export="exportToCsv" @cancel="showImportUser=false"></importcsv>
    </div>
</template>

<script>
import Vue from 'vue'
import server from "./ServerApi.js";
import ObjectTree from "./ObjectTree.vue"
import AddGroup from "./AddGroup.vue";
import AddTalkgroup from "./AddTalkgroup.vue";
import AddUser from "./AddUser.vue";
import ImportCSV from "./ImportCSV.vue";
import UserObject from "./UserObject.vue";
import NodeObject from "./NodeObject.vue";
import TalkgroupObject from "./TalkgroupObject.vue";
import VueVisible from 'vue-visible'
import InitialUserRightPanel from "./InitialUserRightPanel.vue"
import ChatGPTObject from "./ChatGPTObject.vue";
import commonUtil from './commonutil.js';
import constants from './constants.js';

Vue.use(VueVisible)

export default {
    data () {
        return {
            showAddGroup: false,
            showAddTalkgroup: false,
            showAddUser: false,
            showImportUser: false,
            showImportError: false,
            disableCreateGroup: true,
            disableCreateUser: true,
            disableCreateTalkgroup: true,
            selectedNode: null,
            show: false,
            showCsvProcessing: false,
            showImportCsvProcess: false,
            showExportCsvProcess: false,
            csvType: "",
            csvProgress: 0,
            csvAborted: false,
            csvErrorCount: 0,
            csvExportExecTime: 0,
            csvProcessedAll: false,
            timerObj: null,
            aclInfo: {
                rw: null,
                ro: null
            },
            listType: 0,
            importErrorInfo: null,
            csvProcessStatusDescription: null
        }
    },
    methods: {
        addGroupCommand: function() {
            if (this.checkRwAcl()) {
                this.showAddGroup = true;
            } else {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_create_node_denied"));
            }
        },
        addTalkgroupCommand: function() {
            if (this.checkRwAcl()) {
                this.showAddTalkgroup = true;
            } else {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_create_group_denied"));
            }
        },
        addUserCommand: function() {
            if (this.appData.tenantList[0].samlLayer != null) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_create_user_enableSAML"));
                return;
            }
            if (this.checkRwAcl()) {
                this.showAddUser = true;
            } else {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_create_user_denied"));
            }
        },
        addGroup: function(input) {
            this.$data.showAddGroup = false;
            this.$refs.objectTree.addGroup(this.selectedNode, input);
        },
        addTalkgroup: function(input) {
            this.$data.showAddTalkgroup = false;
            this.$refs.objectTree.addTalkgroup(this.selectedNode, input);
        },
        addUser: function(input) {
            this.$data.showAddUser = false;
            this.$refs.objectTree.addUser(this.selectedNode, input);
        },
        exportToCsv: function(exportType) {
            this.csvProcessStatusDescription = commonUtil.getMessageText(this.$i18n,"info_csv_exporting");
            this.showImportUser = false;
            this.csvExportExecTime = 0;
            this.showExportCsvProcess = true;
            let downloadFileName;
            switch(exportType) {
                case "user":
                    downloadFileName = "buddycom_export_user.csv";
                    break;
                case "talkgroup":
                    downloadFileName = "buddycom_export_group.csv";
                    break;
                case "usertalkgroup":
                    downloadFileName = "buddycom_export_usergroup.csv";
                    break;
            }
            this.timerObj = setInterval(function() {self.getCsvProcessState()}, 1000);
            let self = this;
            server.post("/exportcsv", {type: exportType, locale: this.$i18n.locale})
                .then((res) => {
                    self.showExportCsvProcess = false;
                    self.appData.csvProcessing = false;
                    if( typeof res.data.status === 'undefined') {
                        const universalBOM = "\uFEFF";
                        const blob = new Blob([universalBOM + res.data], { type: 'application/csv;charset=UTF-8' })
                        commonUtil.downloadFile(blob, downloadFileName)
                    } else {
                        if (res.data.status === constants.STATUS_ERROR_EXCEEDS_MAX_COUNT) {
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_export_limit"));
                        } else if (res.data.status === constants.STATUS_ERROR_PERMISSION_DENIED) {
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_export_denied"));
                        } else {
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","exportToCsv").replace("{code}",res.data.status));
                        }
                    }
                })
                .catch( function ( error ) {
                    self.showExportCsvProcess = false;
                    self.appData.csvProcessing = false;
                    commonUtil.putExceptionErrorMessage(self, "exportToCsv", error);
                });
        },
        importUser: function(importType , uploadFile) {
            this.showImportUser = false;
            this.csvType = "";
            this.csvProgress = 0;
            this.csvErrorCount = 0;
            this.csvAborted = false;
            this.canceling = false;
            this.csvProcessedAll = false;
            let param = {
                importType: importType,
                csvFileName: uploadFile.name,
            }
            let self = this;
            server.postWithFile("/importcsv", uploadFile, JSON.stringify(param))
                .then((res) => {
                    let msg;
                    switch(res.data.status) {
                        case constants.STATUS_SUCCESS:
                            self.timerObj = setInterval(function() {self.getCsvProcessState()}, 1000)
                            break;
                        case constants.STATUS_BUSY:
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_import_processing"));
                            break;
                        case constants.STATUS_ERROR_EXCEEDS_MAX_SIZE:
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_upload_file_too_big"));
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","importUser").replace("{code}",res.data.status));
                            break;
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "importUser", error);
                });
        },
        getCsvProcessState() {
            clearInterval(this.timerObj);
            this.timerObj = null;
            let self = this;
            server.post("/getcsvprocstate")
                .then((res) => {
                    switch(res.data.status) {
                        case constants.STATUS_SUCCESS:
                            if (res.data.importing && self.isUserMenuCsvProcessType(res.data.importType)) {
                                console.log(self.csvProgress);
                                self.csvType = res.data.importType;
                                self.csvProgress = res.data.progressPercentage;
                                self.csvErrorCount = res.data.errorCount;
                                self.csvProcessedAll = (res.data.processedCount == res.data.totalCount);
                                if (self.csvProcessedAll) {
                                    self.appData.csvProcessing = false;
                                    self.resetCsvImportProcess();
                                    switch(res.data.errorInfo.status) {
                                        case constants.STATUS_SUCCESS:
                                            self.showImportCsvProcess = false;
                                            commonUtil.notifyMessage(self, "Success",commonUtil.getMessageText(self.$i18n,"info_import_complete").replace("{resultCount}",res.data.totalCount));
                                            if (self.selectedNode != null) {
                                                if ((self.selectedNode.node.data.type == constants.OBJECT_USER) || (self.selectedNode.node.data.type == constants.OBJECT_TALKGROUP)) {
                                                    self.$refs.objectInfo.getInfo();
                                                }
                                            }
                                            self.$refs.objectTree.reload();
                                            break;
                                        case constants.STATUS_SUCCESS_WITH_ERRORINFO:
                                            self.showImportCsvProcess = false;
                                            commonUtil.notifyMessage(self, "Success",commonUtil.getMessageText(self.$i18n,"info_import_complete_with_error"));
                                            self.$refs.objectTree.reload();
                                            break;
                                        default:
                                            self.csvProcessStatusDescription = self.getImportStatusDescription();
                                            self.importErrorInfo = res.data.errorInfo;
                                            if (!self.showImportCsvProcess) {
                                                self.showImportCsvProcess = true;
                                            }
                                    }
                                } else {
                                    let errorInfoStatus = res.data.errorInfo.status;
                                    let resetConditionDictionary = [];
                                    resetConditionDictionary[constants.STATUS_ERROR_EXCEEDS_MAX_COUNT] = commonUtil.getMessageText(self.$i18n, "error_csv_exceeds_limit");
                                    resetConditionDictionary[constants.STATUS_ERROR_TOO_MANY_ENTRY] = commonUtil.getMessageText(self.$i18n, "error_csv_exceeds_data");
                                    resetConditionDictionary[constants.STATUS_ERROR_INVALID_CSV_TEMPLATE] = commonUtil.getMessageText(self.$i18n, "error_csv_invalid_template");
                                    resetConditionDictionary[constants.STATUS_ERROR_INVALID_UTF8] = commonUtil.getMessageText(self.$i18n, "error_csv_invalid_utf8");
                                    resetConditionDictionary[constants.STATUS_ERROR_INVALID_CSV_FORMAT] = commonUtil.getMessageText(self.$i18n, "error_csv_invalid_format");
                                    resetConditionDictionary[constants.STATUS_ERROR_UNKNOWN] = commonUtil.getMessageText(self.$i18n, "error_csv_unknown").replace("{errorCode}",errorInfoStatus);

                                    if (errorInfoStatus in resetConditionDictionary) {
                                        self.resetCsvImportProcess();
                                        self.appData.csvProcessing = false;
                                        self.csvAborted = true;
                                        self.csvProcessStatusDescription = resetConditionDictionary[errorInfoStatus];
                                        self.importErrorInfo = res.data.errorInfo;
                                        if (!self.showImportCsvProcess) {
                                            self.showImportCsvProcess = true;
                                        }
                                        return;
                                    }

                                    self.appData.csvProcessing = true;
                                    if (!self.showImportCsvProcess) {
                                        self.showImportCsvProcess = true;
                                    }
                                    if (self.timerObj == null) {
                                        self.timerObj = setInterval(function() {self.getCsvProcessState()}, 1000);
                                    }
                                    self.csvProcessStatusDescription = this.getImportStatusDescription();
                                }
                            } else {
                                if (self.showImportCsvProcess) {
                                    self.appData.csvProcessing = false;
                                    self.canceling = false;
                                    if (res.data.errorInfo.status == constants.STATUS_ERROR_ABORT) {
                                        self.importErrorInfo = res.data.errorInfo;
                                        self.csvAborted = true;
                                    }
                                    self.csvProcessStatusDescription = this.getImportStatusDescription();
                                }
                            }
                            if (res.data.exporting && self.isUserMenuCsvProcessType(res.data.exportType)) {
                                self.csvExportExecTime = Math.floor((Date.now() - new Date(res.data.exportStartTime).getTime()) / 1000);
                                self.showExportCsvProcess = true;
                                self.appData.csvProcessing = true;
                                if (self.timerObj == null) {
                                    self.timerObj = setInterval(function() {self.getCsvProcessState()}, 1000);
                                }
                            } else {
                                if (self.showExportCsvProcess) {
                                    self.appData.csvProcessing = false;
                                    self.showExportCsvProcess = false;
                                }
                            }
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","getCsvProcessState").replace("{code}",res.data.status));
                            self.csvProcessStatusDescription = this.getImportStatusDescription();
                            break;
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "getCsvProcessState", error);
                    clearInterval(self.timerObj);
                    self.timerObj = null;
                });
        },
        isUserMenuCsvProcessType(type) {
            return type === constants.CSV_USER || type === constants.CSV_GROUP || type === constants.CSV_USER_GROUP;
        },
        getImportStatusDescription() {
            if (this.csvAborted) {
                return commonUtil.getMessageText(this.$i18n,"info_csv_import_aborted");
            }
            if (this.csvProcessedAll) {
                return commonUtil.getMessageText(this.$i18n,"info_csv_import_completed");
            }
            if (this.canceling) {
                return commonUtil.getMessageText(this.$i18n,"info_csv_import_aborting");
            }
            return commonUtil.getMessageText(this.$i18n,"info_csv_importing");
        },
        resetCsvImportProcess() {
            let self = this;
            server.post("/changecsvimportprocess",{ type: "RESET", importType: self.csvType })
                .then((res) => {
                    switch(res.data.status) {
                        case constants.STATUS_SUCCESS:
                        case constants.STATUS_ERROR_NOT_FOUND:
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","resetCsvImportProcess").replace("{code}",res.data.status));
                            break;
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "resetCsvImportProcess", error);
                });
        },
        resetSelectedNode() {
            this.selectedNode = null;
        },
        handleShowCsvDialog() {
            if (this.appData.csvProcessing) {
                commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n,"error_import_processing"));
                return;
            }
            this.showImportError = false;
            this.showImportUser=true
        },
        handleOnSelectNode(node) {
            this.selectedNode = node;
        },
        handleChangeListType(type) {
            if (type == 1) {
                this.disableCreateGroup = true;
                this.disableCreateUser = true;
                this.disableCreateTalkgroup = true;
            }
            this.listType = type;
        },
        handleCloseCSVProgress() {
            this.showImportCsvProcess = false;
            if (this.csvErrorCount > 0) {
                this.showImportError = true;
                this.showImportUser=true
            }
        },
        handleCancelImport() {
            this.canceling = true;
            this.csvProcessStatusDescription = this.getImportStatusDescription();
            let self = this;
            server.post("/changecsvimportprocess",{ type: "ABORT", importType: self.csvType })
                .then((res) => {
                    switch(res.data.status) {
                        case constants.STATUS_SUCCESS:
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","handleCancelImport").replace("{code}",res.data.status));
                            break;
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "handleCancelImport", error);
                });
        },
        checkRwAcl() {
            if (this.aclInfo.rw != null) {
                for (let acluser of this.aclInfo.rw) {
                    if (acluser.userName == this.appData.loginId.split("@")[0]) {
                        return true;
                    }
                }
            }
            return false;
        },
        setAclInfo(aclType , aclInfo) {
            if (aclType == 0 ) {
                this.aclInfo.ro = aclInfo;
            } else {
                this.aclInfo.rw = aclInfo;
            }
        },
        enableCreateCommand() {
            this.disableCreateGroup = false;
            this.disableCreateTalkgroup = false;
            this.disableCreateUser = false;
        },
        disableCreateCommand() {
            this.disableCreateGroup = true;;
            this.disableCreateTalkgroup = true;
            this.disableCreateUser = true;
        },
        handleRefreshObjectTree() {
            this.$refs.objectTree.reload();
        },
        getExpireDateTime() {
            if (this.appData.basicContract.purchasePeriodType == constants.PURCHASE_PERIOD_TRIAL) {
                return new Date(this.appData.basicContract.startDatetime).toLocaleString();
            } else {
                return new Date(this.appData.basicContract.nextFlushDatetime).toLocaleString();
            }
        },
        isExpireTrialContract() {
            if ((this.appData.basicContract != null) && (this.appData.basicContract.state == constants.CONTRACT_TRIAL_END)) {
                return true;
            } else {
                return false;
            }
        },
        isExpirePurchasedContract() {
            if ((this.appData.basicContract != null) && (this.appData.basicContract.state == constants.CONTRACT_TERMINATE)) {
                return true;
            } else {
                return false;
            }
        },
        isBillingPaper() {
            if ((this.appData.basicContract != null) && (this.appData.basicContract.billingType == constants.BILLING_PAPER)) {
                return true;
            } else {
                return false;
            }
        },
        showManual() {
            this.showAddTalkgroup = false;
            this.appData.selectedMenu = "manual";
            this.$router.push({path: "/manual" , query: {item: "externalService"}})
        },
    },
    components: {
        objecttree: ObjectTree,
        addgroup: AddGroup,
        addtalkgroup: AddTalkgroup,
        adduser: AddUser,
        importcsv: ImportCSV,
        UserObject: UserObject,
        NodeObject: NodeObject,
        TalkgroupObject: TalkgroupObject,
        InitialUserRightPanel: InitialUserRightPanel,
        ChatGPTObject: ChatGPTObject
    },
    computed: {
        selectedChild: function() {
            if (this.selectedNode != null) {
                switch (this.selectedNode.node.data.type) {
                    case constants.OBJECT_NODE:
                        if (this.appData.csvProcessing) {
                            this.disableCreateCommand();
                        } else {
                            this.enableCreateCommand();
                        }
                        return "NodeObject";
                    case constants.OBJECT_USER:
                        this.disableCreateCommand();
                        return "UserObject";
                    case constants.OBJECT_TALKGROUP:
                        this.disableCreateCommand();
                        return "TalkgroupObject";
                    case constants.OBJECT_ASSISTANT:
                    case constants.OBJECT_CUSTOM_ASSISTANT:
                        // this.disableCreateCommand();
                        // return "ChatGPTObject";
                }
            }
            this.$data.showAddButtons = false;
            this.appData.selectedMenu = 'user';
            return "InitialUserRightPanel";
        },
    },
    created: function() {
        this.getCsvProcessState();
    },
    mounted: function() {
        if (typeof this.$refs.objectTree === "undefined") {
            // should reDraw to load objectTree because objectTree has destroyed when refreshing on the other menu item.
            this.show = false;
            this.$nextTick(() => {
                 if ((this.appData.tenantList != null) && (this.appData.basicContract != null)) {
                    this.show = true
                 }
            })
        }
    },
    watch: {
        showImportCsvProcess(newVal) {
            if (newVal) {
                this.showCsvProcessing = true;
            } else {
                this.showCsvProcessing = false;
            }
        },
        showExportCsvProcess(newVal) {
            if (newVal) {
                this.showCsvProcessing = true;
            } else {
                this.showCsvProcessing = false;
            }
        },
        'appData.tenantList'(newVal) {
            if (newVal != null) {
                if (this.appData.basicContract != null) {
                    this.show = true;
                }
            }
        },
        'appData.basicContract'(newVal) {
            if (newVal != null) {
                if (this.appData.tenantList != null) {
                    this.show = true;
                }
            }
        },
        'appData.csvProcessing'(newVal) {
            if (this.appData.csvProcessing) {
                this.disableCreateCommand();
            } else {
                if (this.selectedNode != null) {
                    switch (this.selectedNode.node.data.type) {
                        case constants.OBJECT_NODE:
                            this.enableCreateCommand();
                            break;
                        case constants.OBJECT_USER:
                        case constants.OBJECT_TALKGROUP:
                            this.disableCreateCommand();
                            break;
                    }
                }
            }
        },
        '$route' (to, from) {
            if (to.name == "User") {
                this.$refs.objectTree.resetCurrentNode(true);
                this.selectedNode = null;
                this.getCsvProcessState();
            }
            if (from.name == "User") {
                clearInterval(this.timerObj);
                this.timerObj = null;
                this.showImportCsvProcess = false;
            }
        }
    },
    props: ['appData']
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
tr.itemheader {
}

.inner-panel {
    position:relative;
    height: 100%;
    width: 100$;
    margin: 0;
    padding: 0;
    overflow: auto;
    background-color: #ffffff;
}

.scrollable {
    overflow: auto;
    position: absolute;
    top: 0;
    right:0;
    bottom: 0;
    left: 0;
}

.command-area {
    background-color: #ecf1fa;
    width: 100%;
    display: block;
    text-align: left;
    padding-left: 20px;
    height: 56px;
    vertical-align: bottom;
}

.command-area img {
  display: inline;
  vertical-align: middle;
  height: 25px;
  padding-left: 16px;
  padding-right: 4px;
}
.command-area-left {
    padding-top: 10px;
    padding-bottom: 10px;
    vertical-align: middle;
    float: left;
}
.command-area-right {
    padding-right: 24px;
    padding-top: 15px;
    text-align : right;
    vertical-align: middle;
}
.normal-command {
    color: #5171cb;

}
.normal-command:hover {
    opacity: 0.7;
}
.csv-progress-title {
    padding: 10px 0 20px 0;
    text-align: center;
}
</style>
